import Vue from "vue";
import VueRouter from "vue-router";
import jwtDecode from 'jwt-decode';
// views
import Inbox from "../views/Inbox.vue";
import Profile from "../views/Profile.vue";
import Chat from "../views/Chat.vue";
import TokenInfo from "../views/TokenInfo.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/register",
    name: "TokenInfo",
    component: TokenInfo
  },
  {
    path: "/:phone_number/",
    name: "Inbox",
    component: Inbox
  },
  {
    path: "/:phone_number/chat/:id",
    name: "Chat",
    component: Chat
  },
  {
    path: "/:phone_number/chat/:id/profile",
    name: "Profile",
    component: Profile
  },
  {
    path: "/:phone_number/chat/:id/:language",
    name: "Chat",
    component: Chat
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  window.onpopstate = () => {
    if (from.name == "Chat") {
      router.push(Inbox).catch(() => {});
    }
  };

  window.scrollTo(0, 0);
  next();
});

router.afterEach(to => {
  const { id: chatId, phone_number: trainingId } = to.params;
  const { token } = to.query;
  const { name } = to;

  if (name !== 'TokenInfo') {
    const store = JSON.parse(localStorage.getItem("store"));
    const isCorrectToken = (token, trainingId) => {
      try {
        const payload = jwtDecode(token);
        return !!(payload['training-id'] && payload['participant-id'] && payload['training-id'] === trainingId);
      } catch (e) {
        return false;
      }
    }

    if (trainingId === 'preview') return;
    
    if (!token || !isCorrectToken(token, trainingId)) {
      router.push(`/register`);
    }
  
    if (store) {
      const { chats } = store;
      const currentChat = chats.all.find(chat => +chat.id === +chatId);
      setTimeout(() => {
        if (currentChat && currentChat.script.length === 0) {
          const pageContent = document.querySelector(".chat-page__wrapper");
          if (pageContent) {
            pageContent.scrollTo(0, pageContent.scrollHeight);
          }
        }
      });
    }
  }  
});

export default router;
